module.exports = __webpack_public_path__ + "static/matza_1@2x-c1406a65588980d5c1953d1cb3444aa4.jpg";